import { citeOutline, outline, TempSentence, WordWithLine } from '../lib/models/interfaces';

export const createSentencePaths = (
  sentence: any,
  width: number,
  height: number
) => {
  // create an arrray of path objects
  const localSentence = sentence as unknown as TempSentence;
  console.log('local sentence', localSentence);
  const lineWords = localSentence.Words.reduce(
    (acc, curr) => {
      if (!acc[curr.LineId]) {
        acc[curr.LineId] = [curr];
      } else {
        acc[curr.LineId].push(curr);
      }
      return acc;
    },
    {} as { [key: string]: WordWithLine[] }
  );
  // create a polygon path for every line using max, min Goemetry of the words.
  const returnArray = Object.keys(lineWords).map((ele) =>
    calculateGeometry(lineWords[ele], width, height)
  );
  return returnArray;
};

// create a polygon path for each line;
const calculateGeometry = (
  words: WordWithLine[],
  width: number,
  height: number
) => {
  const xValues = [];
  const yValues = [];
  let polyString = {} as {
    minX: number;
    minY: number;
    maxX: number;
    maxY: number;
  };
  for (const word of words) {
    for (const polyPoint of word!.Geometry!.Polygon!) {
      xValues.push(polyPoint.X!);
      yValues.push(polyPoint.Y!);
    }
  }
  if (xValues.length > 0 && yValues.length > 0) {
    polyString.minX = Math.min(...xValues);
    polyString.maxX = Math.max(...xValues);
    polyString.minY = Math.min(...yValues);
    polyString.maxY = Math.max(...yValues);
    // polyString = `${minX},${minY} ${maxX},${minY} ${maxX},${maxY} ${minX},${maxY}`;
  }
  return polyString;
};

export const calculateOutline = (
  outlines: outline[],
  pageNumber: number,
  docIndex: number
) => {
  const xValues: number[] = [];
  const yValues: number[] = [];
  outlines.forEach((ele) => {
    xValues.push(ele.maxX, ele.minX);
    yValues.push(ele.maxY, ele.minY);
  });
  const minX = Math.min(...xValues);
  const maxX = Math.max(...xValues);
  const minY = Math.min(...yValues);
  const maxY = Math.max(...yValues);
  const width = maxX - minX;
  const height = maxY - minY;
  return {
    x: minX,
    y: minY,
    width,
    height,
    pageNumber,
    docIndex
  };
};

export const calculateOutlineSentence = (
  outlines: outline[],
  pageNumber: number,
  docIndex: number
) => {
  const returnOutlines: {
    x: number;
    y: number;
    width: number;
    height: number;
    pageNumber: number;
    docIndex: number;
  }[] = [];
  outlines.forEach((ele) => {
    const xValues: number[] = [];
    const yValues: number[] = [];
    outlines.forEach((ele) => {
      xValues.push(ele.maxX, ele.minX);
      yValues.push(ele.maxY, ele.minY);
    });
    const minX = Math.min(...xValues);
    const maxX = Math.max(...xValues);
    const minY = Math.min(...yValues);
    const maxY = Math.max(...yValues);
    const width = maxX - minX;
    const height = maxY - minY;
    returnOutlines.push({
      x: minX,
      y: minY,
      width,
      height,
      pageNumber,
      docIndex
    });
  });
  return returnOutlines;
};

export const mergeOverlappingRegions = (regions: citeOutline[]): citeOutline[] => {
  const merged: citeOutline[] = [];
  const visited = new Array(regions.length).fill(false);

  const overlaps = (a: citeOutline, b: citeOutline): boolean => {
    if (a.docIndex !== b.docIndex || a.pageNumber !== b.pageNumber)
      return false;
    const ax2 = a.x + a.width;
    const ay2 = a.y + a.height;
    const bx2 = b.x + b.width;
    const by2 = b.y + b.height;

    return a.x < bx2 && ax2 > b.x && a.y < by2 && ay2 > b.y;
  };

  for (let i = 0; i < regions.length; i += 1) {
    if (visited[i]) continue;

    let minX = regions[i].x;
    let minY = regions[i].y;
    let maxX = regions[i].x + regions[i].width;
    let maxY = regions[i].y + regions[i].height;
    const { docIndex, pageNumber } = regions[i];

    const stack = [i];
    visited[i] = true;

    while (stack.length > 0) {
      const idx = stack.pop()!;
      const current = regions[idx];

      minX = Math.min(minX, current.x);
      minY = Math.min(minY, current.y);
      maxX = Math.max(maxX, current.x + current.width);
      maxY = Math.max(maxY, current.y + current.height);

      for (let j = 0; j < regions.length; j += 1) {
        if (visited[j]) continue;
        if (!overlaps(current, regions[j])) continue;
        visited[j] = true;
        stack.push(j);
      }
    }

    merged.push({
      x: minX,
      y: minY,
      width: maxX - minX,
      height: maxY - minY,
      docIndex,
      pageNumber
    });
  }

  return merged;
};
